import React from 'react'
import RichTextEditor from '@/shared/RichTextEditor'

// Short rich-text field. Kept as a name so existing call sites don't change;
// everything lives in RichTextEditor.
const TipTapTextarea = (props) => <RichTextEditor variant='textarea' {...props} />

export default TipTapTextarea
